import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsignmentDetailComponent } from '../consignment-detail/consignment-detail.component';
import { LoginComponent } from '../login/login.component';

const routes: Routes = [
  { path: 'consignment-detail', component: ConsignmentDetailComponent },
  { path: 'login/:referrer/:file_name', component: LoginComponent },
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class ConsignmentsRoutingModule { }
